import { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { AdaptedButton } from "../../components/adaptedButton";

export function Page11({ handleClick }) {

  const [selectedValues, setSelectedValues] = useState([]);
  const handleButtonClick = (name, value) => {
    const newSelectedValues = [...selectedValues];
    const valueIndex = newSelectedValues.indexOf(value);
    if (valueIndex === -1) {
      // Add value to selected values
      newSelectedValues.push(value);
    } else {
      // Remove value from selected values
      newSelectedValues.splice(valueIndex, 1);
    }
    setSelectedValues(newSelectedValues);
    handleClick(name, newSelectedValues);
  };
  return (
    <View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Improved hydration'}
            selected={selectedValues.includes('Improved hydration')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce redness'}
            selected={selectedValues.includes('Reduce redness')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce irritation'}
            selected={selectedValues.includes('Reduce irritation')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reverse sun damage'}
            selected={selectedValues.includes('Reverse sun damage')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Treat sunburn'}
            selected={selectedValues.includes('Treat sunburn')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce pore size'}
            selected={selectedValues.includes('Reduce pore size')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce fine lines'}
            selected={selectedValues.includes('Reduce fine lines')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce wrinkles'}
            selected={selectedValues.includes('Reduce wrinkles')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Eliminate black heads'}
            selected={selectedValues.includes('Eliminate black heads')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Eliminate white heads'}
            selected={selectedValues.includes('Eliminate white heads')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce acne'}
            selected={selectedValues.includes('Reduce acne')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Improve elasticity'}
            selected={selectedValues.includes('Improve elasticity')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Brighten tone'}
            selected={selectedValues.includes('Brighten tone')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Even tone'}
            selected={selectedValues.includes('Even tone')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Improve texture'}
            selected={selectedValues.includes('Improve texture')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Fade dark spots'}
            selected={selectedValues.includes('Fade dark spots')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce excess shine'}
            selected={selectedValues.includes('Reduce excess shine')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_goals'}
            fieldValue={'Reduce excess oil'}
            selected={selectedValues.includes('Reduce excess oil')}
          />
        </View>
      </View>
    </View>
  );
}


const styles = StyleSheet.create({
  buttonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    //marginBottom: 10,
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fix: {
    width: '48%',
    //height:'90%',
    margin: 2,
  }
});